window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};


repos.obavijestiRepo = function () {
    var url = 'api/obavijesti';

    var remove = function (naziv) {
        return fetch(url, {
                method: 'DELETE',
                credentials: repos.base.credentials,
                headers: repos.base.headers(),
                body: JSON.stringify({
                    naziv: naziv
                })
            })
            .then(casino.repos.base.checkResponse)
            .catch(casino.repos.base.handleNetworkException);
    };

    return {
        remove: remove
    }

}();